import { Scale } from 'lucide-react'
import type { CoreTension } from '../types'
import { TensionCard } from './tension-card'

export interface EvaluationTensionsProps {
  tensions: CoreTension[]
}

export function EvaluationTensions({ tensions }: EvaluationTensionsProps) {
  const sectionSummary = tensions[0]?.question
  return (
    <div className="mt-8">
      <div className="mb-3 flex items-center gap-2">
        <Scale className="size-4 text-amber-400" />
        <h2 className="text-sm font-semibold text-foreground">Core Tensions</h2>
      </div>
      {sectionSummary && <p className="mb-3 text-sm text-muted-foreground">{sectionSummary}</p>}
      <div className="flex flex-wrap items-start gap-3">
        {tensions.map((t, i) => (
          <div key={`${t.left}-${t.right}-${i}`} className="w-[calc(50%-6px)]">
            <TensionCard tension={t} />
          </div>
        ))}
      </div>
    </div>
  )
}
